import React from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

export default function CookieBanner({ onAccept }) {
  return (
    <div className="cookie-banner" role="region" aria-label="Cookie-samtykke">
      <div className="cookie-banner-inner container">
        <div className="cookie-icon" aria-hidden="true">🍪</div>
        <div className="cookie-text">
          <p>
            <strong>Vi bruger cookies</strong> for at forbedre din oplevelse og analysere trafik på TopCasinoDansk.com.
            Ved at fortsætte accepterer du vores brug af cookies i henhold til vores{' '}
            <Link to="/cookiepolitik">cookiepolitik</Link>.
          </p>
        </div>
        <div className="cookie-actions">
          <button className="btn btn-primary btn-sm" onClick={onAccept}>
            Accepter alle
          </button>
          <Link to="/cookiepolitik" className="cookie-details-link">
            Læs mere
          </Link>
        </div>
      </div>
    </div>
  );
}
